<template>
	<vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">
		<span class="cursor-pointer flex items-center i18n-locale">
			<img class="h-4 w-5" :src="i18n_locale_img" :alt="$i18n.locale" />
			<span class="hidden sm:block ml-2 span-lang">{{ getCurrentLocaleData.lang }}</span>
		</span>
		<vs-dropdown-menu class="w-48 i18n-dropdown vx-navbar-dropdown">
			<vs-dropdown-item @click="updateLocale('en')">
				<img class="h-4 w-5 mr-1" src="@/assets/images/flags/en.png" alt="en" />
				&nbsp;{{ $t("Languages.English") }}
			</vs-dropdown-item>
			<vs-dropdown-item @click="updateLocale('es')">
				<img class="h-4 w-5 mr-1" src="@/assets/images/flags/es.png" alt="pt" />
				&nbsp;{{ $t("Languages.Spanish") }}
			</vs-dropdown-item>
			<vs-dropdown-item @click="updateLocale('pt')">
				<img class="h-4 w-5 mr-1" src="@/assets/images/flags/br.svg" alt="pt" />
				{{ $t("Languages.Portuguese") }}
			</vs-dropdown-item>
		</vs-dropdown-menu>
	</vs-dropdown>
</template>

<script>
import {uiControlHereMap} from "../../../../utils/HereMap";

export default {
	computed: {
		i18n_locale_img() {
			// Use below code to dynamically fetch image instead of if-else
			// NOTE: We used if-else because laravel throws error in 'yarn prod'.
			// If you are not using laravel + Vue, you can use below code to dynamically get image
			// return require(`@/assets/images/flags/${this.$i18n.locale}.png`)

			const locale = this.$i18n.locale;
			if (locale === "en") return require("@/assets/images/flags/en.png");
			else if (locale === "pt") return require("@/assets/images/flags/br.svg");
			else if (locale === "fr") return require("@/assets/images/flags/fr.png");
			else if (locale === "de") return require("@/assets/images/flags/de.png");
			else if (locale === "es") return require("@/assets/images/flags/es.png");
			else return require("@/assets/images/flags/en.png");
		},
		getCurrentLocaleData() {
			const locale = this.$i18n.locale;
			if (locale === "en") return {flag: "us", lang: this.$t("Languages.Eng")};
			else if (locale === "pt") return {flag: "br", lang: this.$t("Languages.Por")};
			else if (locale === "fr") return {flag: "fr", lang: this.$t("Languages.Fre")};
			else if (locale === "de") return {flag: "de", lang: this.$t("Languages.Ger")};
			else if (locale === "es") return {flag: "es", lang: this.$t("Languages.Spa")};
		},
	},
	methods: {
		updateLocale(locale) {
			this.$i18n.locale = locale;
			uiControlHereMap(locale, this.$store.state.moduleMap.module);
			this.$store.commit("UPDATE_LOCALE_APP", locale);
		},
	},
};
</script>
